












import { Component, Prop, Vue } from 'vue-property-decorator'
import { LocationModel, Locations, UserState, Templates } from '../models'

@Component
export default class LocationPicker extends Vue {
  protected email: string = ''
  protected password: string = ''

  get existingLocations() {
    return Locations.entities
  }

  get locationsAreLoading() {
    return Locations.isLoading
  }

  authenticateUser() {
    const { email, password } = this
    UserState.LOGIN({ email, password })
  }

  setLocation(location: LocationModel) {
    Locations.SET_ACTIVE_LOCATION_ID(location.id)
  }
}
